import API from "Services/Api";
import ApiAcuity from "Services/ApiAcuity";

import { createToast } from "Utils/toastFunc";

export async function getClinicUnitsByUser() {
  try {
    const res = await ApiAcuity.get(`/units-temp`, {
      params: {
        type: "clinica",
      },
    });
    return res;
  } catch (error) {
    createToast("error", "Não foi possível buscar unidades.");
  }
}

function getDownloadFilename(
  contentDisposition: string | undefined,
  fallback: string
): string {
  if (!contentDisposition) return fallback;
  const utf8 = /filename\*=UTF-8''([^;\s]+)/i.exec(contentDisposition);
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1].replace(/^["']|["']$/g, ""));
    } catch {
      return utf8[1];
    }
  }
  const ascii = /filename=(?:"([^"]+)"|([^;\s]+))/i.exec(contentDisposition);
  const name = ascii?.[1] ?? ascii?.[2];
  return name?.trim() ? name.trim() : fallback;
}

function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

async function tryToastFromJsonBlob(blob: Blob): Promise<boolean> {
  if (!blob.type.includes("json")) return false;
  try {
    const text = await blob.text();
    const parsed = JSON.parse(text) as { message?: string };
    createToast(
      "error",
      parsed.message ?? "Não foi possível baixar o QR code."
    );
    return true;
  } catch {
    return false;
  }
}

export const getUnitQRcode = async (unitId: number | string) => {
  if (unitId === "" || unitId === undefined || unitId === null) {
    createToast("error", "Salve a unidade antes de baixar o QR code.");
    return;
  }

  const id = Number(unitId);
  if (Number.isNaN(id) || id === 0) {
    createToast("error", "Identificador da unidade inválido.");
    return;
  }

  const fallbackName = `qrcode-unidade-${id}.pdf`;

  try {
    const response = await API.get(`/unit/${id}/qrcode/pdf`, {
      responseType: "blob",
    });

    const blob = response.data as Blob;
    const contentType = response.headers["content-type"] ?? "";

    if (contentType.includes("application/json")) {
      const showed = await tryToastFromJsonBlob(blob);
      if (!showed) {
        createToast("error", "Não foi possível baixar o QR code.");
      }
      return;
    }

    const filename = getDownloadFilename(
      response.headers["content-disposition"],
      fallbackName
    );
    triggerBrowserDownload(blob, filename);
  } catch (error: unknown) {
    const err = error as { response?: { data?: Blob } };
    const blob = err.response?.data;
    if (blob instanceof Blob && blob.type.includes("json")) {
      const showed = await tryToastFromJsonBlob(blob);
      if (showed) return;
    }
    createToast("error", "Não foi possível buscar o QR code da unidade.");
  }
};
